import {
  NewsContent,
  NewsHeading,
  NewsParagraph,
  NewsSpacer,
  NotesList,
} from "components/News";
import { useEffect, useState } from "react";

import AdvancedPotionMakingEditionII from "assets/replicas/harry-potter/hp-advanced-potion-making/edition-II";
import AdvancedPotionMakingPrincesCopy from "assets/replicas/harry-potter/hp-advanced-potion-making/edition-II-prince's-copy";
import BooksImage from "./books.png";
import { Link } from "react-router-dom";
import type { NewsItemType } from "..";
import { common } from "config/common";
import { createDate } from "utils";
import { routes } from "config";
import styled from "styled-components";

/* import ThumbnailImg from "assets/replicas/harry-potter/hp-advanced-potion-making/edition-II-prince's-copy/v3/thumbnail.png"; */

const ColumnContent = styled.div`
  width: 100%;
  margin-top: 20px;
  margin-bottom: 10vh;

  .news-image {
    float: right;
    width: min(240px, 40%);
    margin: -20px 0 1rem 2rem;

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  ${(props) => props.theme.breakpoints.M} {
    padding-right: 0;

    .news-image {
      margin: -20px 0 1rem 2rem;
      width: min(240px, 42%);
    }
  }

  ${(props) => props.theme.breakpoints.S} {
    .news-image {
      margin: -20px -5% 3% 2%;
      width: min(240px, 40%);
    }
  }
`;

const ColumnImage = styled.div`
  ${(props) => props.theme.breakpoints.S} {
    float: none;
    margin: 0 auto 1.5rem;

    img {
      height: auto;
      display: block;
      margin: 0 auto;
    }
  }
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 6vh;
  margin-bottom: 3vh;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  * {
    margin: 0;
  }
`;

const StyledLink = styled(Link)`
  margin-left: 6px;
  text-decoration: underline;
  font-weight: 600;
  color: ${(props) => props.theme.colors.black}AA !important;
`;

const NewsItemTitle = styled.h2`
  /*   margin: 0;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  line-height: 1.5em;

  ${(props) => props.theme.breakpoints.S} {
    font-size: 14px;
  } */
`;

const NewsItemTitleBig = styled.h3`
  /*   margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-align: center;
  text-transform: uppercase;
  line-height: 1.5em;

  ${(props) => props.theme.breakpoints.S} {
    font-size: 18px;
  } */
`;

/* const Thumbnail = styled.img`
  width: 100%;
  max-height: 280px;
  object-fit: contain;
  margin-bottom: 20px;
`; */

const CountdownText = styled.strong`
  display: inline-block;
  margin-top: 0.2rem;
  font-size: 1.2em;
  font-weight: 800;
  margin: 0;
  margin-top: 8px;
  margin-bottom: 6px;
  margin-left: 6px;
  color: ${(props) => props.theme.colors.black}AA !important;
`;

const TIMER_END_DATE = createDate({ day: 7, month: 7, year: 2026 });
const TIMER_CLOSED_TEXT = "Time period closed";

const Countdown = () => {
  const [countdownText, setCountdownText] = useState(TIMER_CLOSED_TEXT);

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const distanceMs = TIMER_END_DATE.getTime() - now.getTime();

      if (distanceMs <= 0) {
        setCountdownText(TIMER_CLOSED_TEXT);
        return;
      }

      const totalMinutes = Math.floor(distanceMs / (1000 * 60));
      const days = Math.floor(totalMinutes / (60 * 24));
      const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
      const minutes = totalMinutes % 60;

      setCountdownText(`${days} days ${hours} hours ${minutes} minutes`);
    };

    updateCountdown();
    const intervalId = window.setInterval(updateCountdown, 1000 * 30);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  return <CountdownText>{countdownText}</CountdownText>;
};

/* NEWS DATA */
export const NEWS_DATA: NewsItemType = {
  datePublished: createDate({ day: 28, month: 6, year: 2026 }),
  dateHidden: createDate({ day: 12, month: 7, year: 2026 }),
  page: undefined,
};

/* NEWS PAGE */
const Page = () => {
  return (
    <NewsContent>
      {/* <Thumbnail
        src={ThumbnailImg}
        alt="Advanced Potion-Making (Edition II) v3 replica"
      /> */}

      <Title>
        <NewsItemTitle>{`Advanced Potion-Making\n(Edition II) v3`}</NewsItemTitle>

        <NewsItemTitleBig>released and ready for shipping!</NewsItemTitleBig>
      </Title>

      <ColumnContent>
        <ColumnImage className="news-image">
          <img
            src={BooksImage}
            alt="A stack of Advanced Potion-Making v3 replicas"
          />
        </ColumnImage>

        <NewsParagraph>
          The third version of my Advanced Potion-Making (Edition II) replica is
          now officially out! Since many people have been waiting for a copy of
          my Advanced Potion-Making replica, I wanted to make sure to be ready
          upon release, to a certain degree, and spent the last six months
          making multiple copies that are now ready for shipping.
        </NewsParagraph>

        <NewsSpacer />

        <NewsParagraph>
          The majority are Prince's Copy editions, but I also have a few Clean
          versions and a sort of DIY cover kit available (more information can
          be found on the{" "}
          <Link to={"/" + routes.replicasFAQ.slug} target="_blank">
            Replicas FAQ page
          </Link>{" "}
          - password is <b>mellon</b>). More information can be requested via
          email, as orders are also handled exclusively via email.
        </NewsParagraph>

        <NewsHeading>
          Please read carefully to get the best chance at securing a copy:
        </NewsHeading>
        <NotesList>
          <li>
            Orders accepted only by emailing me at <b>{common.contact.email}</b>
          </li>
          <li>Include the country you want the replica shipped to.</li>
          <li>
            <Column>
              <span>Include the name and version of the replica:</span>

              <StyledLink
                to={
                  "/" +
                  routes.replicaDetail.slug.replace(
                    ":id",
                    AdvancedPotionMakingPrincesCopy.id,
                  )
                }
                target="_blank"
              >
                Advanced Potion-Making (Edition II) v3 - Prince's copy
              </StyledLink>

              <StyledLink
                to={
                  "/" +
                  routes.replicaDetail.slug.replace(
                    ":id",
                    AdvancedPotionMakingEditionII.id,
                  )
                }
                target="_blank"
              >
                Advanced Potion-Making (Edition II) v3 - Clean copy
              </StyledLink>
            </Column>
          </li>
          <li>
            If your email address is on the waitlist for this replica, it may be
            given preference in the allocation of available copies. For this
            reason, <strong>no orders will be confirmed</strong> before this
            time period has ended:
            <br />
            <Countdown />
          </li>
          <li>
            After the time period has ended, if demand exceeds the number of
            available copies, I will sort the orders based on several factors,
            with the date and time of your order and your position on the
            waitlist being the primary considerations.
          </li>
        </NotesList>

        <NewsHeading>Disclaimers and Notes:</NewsHeading>
        <NotesList>
          <li>
            Please note that my response times are notoriously slow, especially
            when being flooded with emails, so do not be alarmed if you do not
            receive a response immediately - the time of me receiving your email
            is what counts, not the time of my response.
          </li>
          <li>
            The current waitlist will be cleared once the ordering period has
            ended. If you do not manage to secure a copy, please note that you
            are not automatically added to a new waitlist - you will need to
            email me about being added to the new waitlist.
          </li>
          <li>
            No additional made-to-order replicas are planned for the foreseeable
            future.
          </li>
          <li>
            No reserving of replicas for later purchase. Orders are expected to
            be completed without much delay, as reserving replicas in the past
            proved to be a mistake.
          </li>
          <li>
            Although the handling of orders for this replica is treated
            differently with regards to it being a new release, it is still
            possible to include other replicas in your order as well.
          </li>
        </NotesList>
      </ColumnContent>
    </NewsContent>
  );
};

export default {
  ...NEWS_DATA,
  page: <Page />,
} as NewsItemType;
